import { useCallback } from 'react'
import { useApolloClient, useMutation } from '@apollo/client'
import { useRouter } from 'next/router'
import { LogoutDocument } from '@lib/graphql/documents.generated'
import { setAccessToken } from '@lib/utils/access-token'

export const useLogout = () => {
  const router = useRouter()
  const client = useApolloClient()

  const [logoutMutation] = useMutation(LogoutDocument, {
    onCompleted: () => {
      client.cache.evict({ fieldName: 'me' })
      router.replace(router.asPath)
      router.reload()
    },
  })

  const logout = useCallback(() => {
    setAccessToken('')
    logoutMutation()
  }, [logoutMutation])

  return { logout }
}
